export default "__VITE_ASSET__DaOd2H6i__"